import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=602845d9&scoped=true"
import script from "./Surveys.vue?vue&type=script&lang=ts"
export * from "./Surveys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602845d9",
  null
  
)

export default component.exports